/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CancelCardResponseProductCardImageDetailsOneOfCardOrientation = typeof CancelCardResponseProductCardImageDetailsOneOfCardOrientation[keyof typeof CancelCardResponseProductCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelCardResponseProductCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
